import {
  FormControl, FormErrorMessage, FormLabel, Input,
  InputGroup,
  InputLeftElement,
  Text,
} from '@chakra-ui/react';
import React from 'react';

const SubjectField = ({ register, getFieldState }) => {
  const { invalid, error } = getFieldState('subject');

  return (
    <FormControl my="4" isRequired isInvalid={invalid}>
      <FormLabel fontSize="sm">Subject:</FormLabel>
      <InputGroup>
        <InputLeftElement pointerEvents="none" width="auto" px="3" color="gray.500">
          <Text as="span">[Submize]</Text>
        </InputLeftElement>
        <Input {...register('subject', { required: true })} pl="20" />
      </InputGroup>

      <FormErrorMessage>{error?.message}</FormErrorMessage>

    </FormControl>
  );
};

export default SubjectField;
